import React from 'react';
import { FinanceResponseData } from '@upstart/harmony/lib/legos/financingTypes';
import { SectionItem, SubsectionItem } from './FormItems';
import Input from '../../../../components/PencilEditor/Input/Input';
import { parseNumber } from '../../../../util/format';

interface InputProps {
  title?: string;
  subtitle?: string;
  description?: React.ReactElement | null;
  field: string;
  value: any;
  onChange: (data: Partial<FinanceResponseData>) => void;
  required?: boolean;
}

interface NumberInputProps extends InputProps {
  field: string;
  value: number | undefined;
}

interface StringInputProps extends InputProps {
  value: string | undefined;
}

interface NumberBaseProps extends NumberInputProps {
  BaseItem: typeof SectionItem | typeof SubsectionItem;
}

interface StringBaseProps extends StringInputProps {
  BaseItem: typeof SectionItem | typeof SubsectionItem;
}

export function BaseNumberInputItem(props: NumberBaseProps) {
  return (
    <props.BaseItem
      title={props.title}
      subtitle={props.subtitle}
      description={props.description}
      value={
        <Input
          placeholder="N/A"
          className="generic-form-input-item"
          value={props.value}
          required={props.required}
          onChange={(val: number) =>
            props.onChange({ [props.field]: parseNumber(val) })
          }
        />
      }
    />
  );
}

export function BaseStringInputItem(props: StringBaseProps) {
  return (
    <props.BaseItem
      title={props.title}
      subtitle={props.subtitle}
      description={props.description}
      value={
        <Input
          placeholder="N/A"
          className="generic-form-input-item"
          value={props.value}
          required={props.required}
          onChange={(val: string) => props.onChange({ [props.field]: val })}
        />
      }
    />
  );
}
export function SectionNumberInputItem(props: NumberInputProps) {
  return <BaseNumberInputItem {...props} BaseItem={SectionItem} />;
}

export function SectionStringInputItem(props: StringInputProps) {
  return <BaseStringInputItem {...props} BaseItem={SectionItem} />;
}
